import { createFileRoute } from '@tanstack/react-router';
import DocumentDetailPage from '@/pages/documents/DocumentDetailPage';

export const Route = createFileRoute('/_authenticated/documents/$id')({
  component: DocumentDetailPage,
});
